import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent, useState } from 'react';

import { I18nProviderWrapper } from '../I18nProviderWrapper';

import { GifWizard } from './GifWizard';
import { UploadArea, UploadAreaProps } from './UploadArea';

interface BackgroundImageUploaderProps {
  uploaderProps: UploadAreaProps;
}

export const BackgroundImageUploader: FunctionComponent<BackgroundImageUploaderProps> = ({ uploaderProps }) => {
  const [open, setOpen] = useState(false);

  return (
    <I18nProviderWrapper>
      <UploadArea {...uploaderProps} onClick={(): void => { setOpen(true); }} />
      <GifWizard
        gifHelpText={<Trans>GIFs less than 10MB in size are recommended.</Trans>}
        id="background-image-customization"
        open={open}
        setOpen={setOpen}
        stillHelpText={<Trans>JPG, PNG, or WebPs with minimum size of 1920 x 1080px are recommended</Trans>}
        title={t`Sign In Background Image`}
        uploaderProps={uploaderProps}
      />
    </I18nProviderWrapper>
  );
};
